import { BookingChangeKind } from '@/features/dashboard/bookingChanges/types/dto/BookingChangeKind.ts';

/**
 * Jak nazywa się paczka danego rodzaju.
 *
 * Edycja jest rodzajem domyślnym i nazywa się po prostu paczką — dopisywanie
 * „edycja” przy każdej pozycji historii byłoby szumem. Rezygnacja to inna
 * operacja (znika uczestnik, nie kwota) i ma się od tamtych odróżniać na
 * pierwszy rzut oka.
 */
const CHANGE_KIND_NAMES: Record<BookingChangeKind, string> = {
  [BookingChangeKind.EDIT]: 'Paczka',
  [BookingChangeKind.WITHDRAWAL]: 'Rezygnacja',
};

/** Nagłówek pozycji historii: „Paczka #7”, „Rezygnacja #7”. */
export const changePackageHeading = (
  kind: BookingChangeKind,
  packageNumber: number,
): string => `${CHANGE_KIND_NAMES[kind]} #${packageNumber}`;
